import "core-js/modules/es6.regexp.split.js";
var baseUri = process.env.NODE_ENV === 'development' ? 'http://192.168.178.207:3333' : 'https://' + window.location.hostname + '/portal'; // get cookie

function getCookie(cname) {
  var name = cname + '=';
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');

  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];

    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }

    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }

  return '';
}

export default {
  nodeEnv: process.env.NODE_ENV,
  production: process.env.NODE_ENV === 'development',
  baseUri: baseUri,
  storageUri: baseUri + '/storage/',
  selectOptions: function selectOptions(data, value, label) {
    var list = [];
    data.forEach(function (obj) {
      var objLabel = '';

      if (label.constructor === Array) {
        label.forEach(function (o, index) {
          if (index > 0) {
            objLabel += ' (';
          }

          objLabel += "".concat(obj[o]);

          if (index > 0) {
            objLabel += ')';
          }
        });
      } else {
        objLabel = obj[label];
      }

      list.push({
        value: obj[value],
        label: objLabel.trim()
      });
    });
    return list;
  },
  auStates: ['ACT', 'NSW', 'QLD', 'SA', 'NT', 'TAS', 'VIC', 'WA'],
  genders: [{
    label: 'Male',
    value: 'male'
  }, {
    label: 'Female',
    value: 'female'
  }, {
    label: 'Other',
    value: 'other'
  }],
  upload: {
    url: '/api/upload',
    headers: [{
      name: 'X-XSRF-TOKEN',
      value: getCookie('XSRF-TOKEN')
    }],
    images: 'image/jpeg,image/png',
    documents: 'image/jpeg,.pdf',
    fieldName: 'file'
  }
};